export const CANTEEN_NAVBAR_ID = 'canteen-navbar'
